import axiosInstance from "./api_helper";

const customerReturnService = {
  list: ({ clientId, shiftId, dateFrom, dateTo, commercialId, query, amount, paymentFilter, sortField, sortDirection }) => {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (shiftId !== undefined && shiftId !== null) params.shiftId = shiftId;
    if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (query) params.query = query;
    if (amount !== undefined && amount !== null && amount !== '') params.amount = amount;
    if (paymentFilter) params.paymentFilter = paymentFilter;
    if (sortField) params.sortField = sortField;
    if (sortDirection) params.sortDirection = sortDirection;

    return axiosInstance.get(`/api/retours-client`, { params });
  },

  linked: (references) => axiosInstance.get('/api/retours-client/linked', { params: { references: references.join(',') } }),

  resume: (params) => {
    return axiosInstance.get(`/api/retours-client/resume`, { params });
  },

  search: (params) => {
    return axiosInstance.get(`/api/retours-client/search`, { params });
  },
  generateNumero: () => {
    return axiosInstance.get(`/api/retours-client/generate-number`);
  },
  getById: (id) => {
    return axiosInstance.get(`/api/retours-client/${id}`);
  },

  availableCredits: (clientId) => {
    return axiosInstance.get(`/api/retours-client/client/${clientId}/avoirs-disponibles`);
  },

  create: (data) => {
    return axiosInstance.post(`/api/retours-client`, data);
  },

  update: (id, data) => {
    return axiosInstance.put(`/api/retours-client/${id}`, data);
  },

  validate: (id) => {
    return axiosInstance.post(`/api/retours-client/${id}/validate`);
  },

  cancel: (id) => {
    return axiosInstance.post(`/api/retours-client/${id}/cancel`);
  },

  delete: (id) => {
    return axiosInstance.delete(`/api/retours-client/${id}`);
  },

  generatePdf: (id) => {
    return axiosInstance.get(`/api/retours-client/${id}/pdf`, {
      responseType: 'blob'
    });
  }
};

export default customerReturnService;
